import React from 'react';
import { SectionTitle, SubsectionWrapper, SectionWrapper } from 'screens/DeveloperPage/styled';
import Description from 'components/description';
import { useLocale } from 'locale';
import { IDeveloperAward } from 'utils/entities';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import ProjectCounters from './ProjectCounters';
import { Awards } from './Awards';
import * as Styled from './styled';
import { PromotionVideo } from './PromotionVideo';

const DESCRIPTION_LIMIT_MOBILE = 310;
const DESCRIPTION_LIMIT_DESKTOP = 703;

interface DeveloperInfoProps {
  descriptionOnly: boolean;
  description: string;
  awards: IDeveloperAward[];
  shouldPresentProjectCounter: boolean;
  videoUrl: string;
}

const DeveloperInfo: React.FC<DeveloperInfoProps> = (props) => {
  const { description, descriptionOnly, awards, shouldPresentProjectCounter, videoUrl } = props;
  const isMobile = useScreenBreakpoint() === 1;
  const { t } = useLocale();
  const showCounters = shouldPresentProjectCounter && !isMobile;


  const descriptionSection = description ? (
    <SubsectionWrapper withBorder={isMobile} noTopMargin={!isMobile}>
      <SectionTitle>{t('developerPage.mainInfo.description.title')}</SectionTitle>
      <Styled.DescriptionWrapper>
        <Description
          limit={isMobile ? DESCRIPTION_LIMIT_MOBILE : DESCRIPTION_LIMIT_DESKTOP}
          description={description}
        />
      </Styled.DescriptionWrapper>
    </SubsectionWrapper>
  ) : null;

  if (descriptionOnly) {
    return (
      <SectionWrapper>
        {descriptionSection}
      </SectionWrapper>
    );
  }

  const projectCounters = shouldPresentProjectCounter ? <ProjectCounters /> : null;

  return (
    <>
      <SectionWrapper>
        <Styled.MainInfoWrapper showCounters={showCounters}>
          {descriptionSection}
          <ShowAt from={2}>
            {projectCounters}
          </ShowAt>
        </Styled.MainInfoWrapper>
      </SectionWrapper>
      <Awards awards={awards} />
      <ShowAt at={1}>
        {projectCounters}
      </ShowAt>
      {videoUrl ? (
        <SectionWrapper noTopMargin>
          <PromotionVideo videoUrl={videoUrl} />
        </SectionWrapper>
      ) : null}
    </>
  );
};

export default React.memo(DeveloperInfo);
